import { render, staticRenderFns } from "./SettingsVersions.vue?vue&type=template&id=46559029&scoped=true"
import script from "./SettingsVersions.vue?vue&type=script&lang=js"
export * from "./SettingsVersions.vue?vue&type=script&lang=js"
import style0 from "./SettingsVersions.vue?vue&type=style&index=0&id=46559029&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46559029",
  null
  
)

export default component.exports